import { IForm } from 'core-components/classes/models/IForm'
import { ITableProps } from 'core-components/library/list/types'
import { ModalDialog } from 'core-components/library/modalDialog'
import { BaseCrud } from 'core-components/types'

import { EditItemContent } from './editItemContentModal/EditItemContent'

interface IEditItemContentModal {
  item: IForm
  columns: ITableProps['columns']
  onClose: () => void
  source: BaseCrud
}
export const EditItemContentModal = ({ item, columns, onClose, source }: IEditItemContentModal) => {
  return (
    <ModalDialog
      content={EditItemContent}
      size={'md'}
      contentProps={{
        item,
        columns,
        source,
        onClose,
      }}
      title={item.EntryId > -1 ? 'Update item' : 'Create item'}
      show={!!item}
      onClose={onClose}
    />
  )
}
